var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-header bg-white" }, [
      _c("h5", { staticClass: "me-auto" }, [_vm._v(_vm._s(_vm.title))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-body p-0" },
      [
        [
          _c(
            "v-data-table",
            {
              staticClass: "elevation-1 table-sm",
              attrs: {
                headers: _vm.headers.filter(function (e, i) {
                  if (_vm.is_open) {
                    return e
                  } else {
                    if (i > 0) {
                      return e
                    }
                  }
                }),
                items: _vm.data,
                "hide-default-footer": "",
                dense: "",
                "items-per-page": -1,
              },
              scopedSlots: _vm._u(
                [
                  _vm.is_open
                    ? {
                        key: "item.remove",
                        fn: function (ref) {
                          var item = ref.item
                          var index = ref.index
                          return [
                            _c(
                              "v-tooltip",
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          item.state_id == 3 ||
                                          item.state_id == 2
                                            ? _c(
                                                "a",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass:
                                                        "text-gv-danger mx-1",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.REMOVE(
                                                            item,
                                                            index
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "a",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "bi bi-x-circle-fill",
                                                  }),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-muted mx-1 disabled",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "bi bi-x-circle-fill",
                                                  }),
                                                ]
                                              ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_vm._v(" "), _c("small", [_vm._v("Quitar")])]
                            ),
                          ]
                        },
                      }
                    : null,
                  {
                    key: "item.id",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.globalViewOption("PackageDetail")
                          ? _c(
                              "router-link",
                              {
                                staticClass: "text-decoration-none",
                                attrs: {
                                  to: {
                                    name: "PackageDetail",
                                    params: { id: item.id },
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(item.type) +
                                    _vm._s(item.id) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _c("div", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item.type) +
                                  _vm._s(item.id) +
                                  "\n                    "
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "item.pieces",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(Number(item.pieces || 0).toFixed(2)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.description",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            staticClass: "mx-1",
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      Array.isArray(item.description)
                                        ? _c(
                                            "div",
                                            _vm._g(
                                              _vm._b(
                                                { staticClass: "nowrap" },
                                                "div",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(item.description[0]) +
                                                  " ...\n                            "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "small",
                              _vm._l(
                                item.description,
                                function (description, key) {
                                  return _c("div", { key: key }, [
                                    _vm._v(_vm._s(description)),
                                  ])
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.lengthy",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(Number(item.lengthy || 0).toFixed(2)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.width",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(Number(item.width || 0).toFixed(2)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.tall",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(Number(item.tall || 0).toFixed(2)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.weight",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(Number(item.weight || 0).toFixed(2)) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.volumetric_weight",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              Number(item.volumetric_weight || 0).toFixed(2)
                            ) +
                            "\n                "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.files",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          _vm._l(item.files, function (file, index) {
                            return _c(
                              "span",
                              {
                                staticClass:
                                  "badge badge-light badge-pill mr-1",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "text-decoration-none",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onPath(file.id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(index + 1))]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _c("template", { slot: "body.append" }, [
                _c("tr", { staticStyle: { color: "rgba(0,0,0,.6)" } }, [
                  _vm.is_open ? _c("th", [_vm._v("Quitar")]) : _vm._e(),
                  _vm._v(" "),
                  _c("th", [_vm._v("Transportista")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("WH #")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Consignatario")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Identificación")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Piezas")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Embalaje")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Descripción")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("L")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("W")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("H")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Peso")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Vol")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Transportista")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("No. Tracking")]),
                  _vm._v(" "),
                  _c("th"),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _vm.is_open
                    ? _c("td", { staticClass: "text-start" })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass: "text-right",
                      staticStyle: { color: "rgba(0,0,0,.6)" },
                    },
                    [_c("b", [_vm._v("Total:")])]
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          Number(
                            _vm.data.reduce(function (accumulator, object) {
                              return accumulator + parseFloat(object.pieces)
                            }, 0) || 0
                          ).toFixed(2)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          Number(
                            _vm.data.reduce(function (accumulator, object) {
                              return accumulator + parseFloat(object.lengthy)
                            }, 0) || 0
                          ).toFixed(2)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          Number(
                            _vm.data.reduce(function (accumulator, object) {
                              return accumulator + parseFloat(object.width)
                            }, 0) || 0
                          ).toFixed(2)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          Number(
                            _vm.data.reduce(function (accumulator, object) {
                              return accumulator + parseFloat(object.tall)
                            }, 0) || 0
                          ).toFixed(2)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          Number(
                            _vm.data.reduce(function (accumulator, object) {
                              return accumulator + parseFloat(object.weight)
                            }, 0) || 0
                          ).toFixed(2)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          Number(
                            _vm.data.reduce(function (accumulator, object) {
                              return (
                                accumulator +
                                parseFloat(object.volumetric_weight)
                              )
                            }, 0) || 0
                          ).toFixed(2)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                  _vm._v(" "),
                  _c("td", { staticClass: "text-start" }),
                ]),
              ]),
            ],
            2
          ),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }